import { define } from '../../../../utils/typeUtils'
import { PanelWrapper, Action, Badge, Column, Data, FieldType, FieldValue, List, ModalId, RequestAction, UIPermission, useUIActions } from '../../../../features/ui'
import { Request, RequestStatus, UserRole, useSystemState, useSystemStateHooks } from '../../../system'
import { useState } from 'react'
import { ResolveRequestModal } from '../resolve-request-modal/resolveRequestModal'
import { Labels } from '../../../../features/data-types'

export const RequestList = () => {
    const { requests, userRequest, companyUsers } = useSystemState()
    
    const [currentRequest, setCurrentRequest] = useState<Request>()
    const [currentRequestAction, setCurrentRequestAction] = useState<RequestAction>()
    
    const { companyId, userHasPermission } = useSystemStateHooks()
    const readOnly = !userHasPermission(UIPermission.SAVE_REQUESTS)

    const companyRequests = requests.filter(request => request.companyId === companyId)
    
    const { toggleModal } = useUIActions()
    
    const columns: Column[] = [
        {
            name: 'userName',
            type: FieldType.TEXT,
            label: 'Usuario'
        },
        {
            name: 'userEmail',
            type: FieldType.TEXT,
            label: 'Email'
        },
        {
            name: 'role',
            type: FieldType.TEXT,
            label: 'Rol',
            render: (value?: FieldValue) => <Badge label={Labels.userRoleLabel(define(value) as UserRole)} />
        },
        {
            name: 'status',
            type: FieldType.TEXT,
            label: 'Estado',
            render: (value?: FieldValue) => <Badge label={Labels.requestStatusLabel(define(value) as RequestStatus)} />
        },
    ]

    const rows: Data[] = companyRequests
        .filter(request => request.id !== userRequest?.id)
        .map(request => {
            const companyUser = define(companyUsers.find(user => user.id === request.userId))

            return {
                id: request.id,
                userName: companyUser.name,
                userEmail: companyUser.email,
                role: request.role,
                status: request.status
            }
        })

    const onResolve = (requestAction: RequestAction) => (requestId?: string) => {
        setCurrentRequest(companyRequests.find(request => request.id === define(requestId)))
        setCurrentRequestAction(requestAction)
        toggleModal(ModalId.RESOLVE_REQUEST)
    }

    const actions = (requestId?: string): Action[] => {
        const request = companyRequests.find(request => request.id === define(requestId))
        const isPending = request?.status === RequestStatus.PENDING
        
        return isPending && !readOnly ? [
            { icon: 'patch-check-fill', tooltip: 'Aprobar', onClick: onResolve(RequestAction.APPROVE) },
            { icon: 'patch-minus-fill', kind: 'secondary', tooltip: 'Denegar', onClick: onResolve(RequestAction.DENY) }
        ] : []
    }

    return (
        <PanelWrapper title="Solicitudes de Acceso" wide>
            <List
                columns={columns}
                rows={rows}
                rowId="id"
                actions={actions}
                readOnly={readOnly}
            />
            <ResolveRequestModal
                request={currentRequest}
                requestAction={currentRequestAction}
            />
        </PanelWrapper>
    )
}
